import { getCreatorLicense } from "../../../services/creatorApi";
import { isCandidateLoggedIn } from "../../../utils/candidateAuth";

export const CREATOR_LICENSE_PATH = "/creator/license";

export async function loadCreatorLicenseStatus() {
  const data = await getCreatorLicense();
  const license = data.license || {};
  return {
    license,
    accepted: Boolean(license.accepted),
    mustAccept: Boolean(license.must_accept),
    version: license.version,
  };
}

export function creatorLicensePath(nextPath) {
  if (
    typeof nextPath === "string" &&
    (nextPath.startsWith("/me/creator") || nextPath === "/creator/license")
  ) {
    return `${CREATOR_LICENSE_PATH}?next=${encodeURIComponent(nextPath)}`;
  }
  return CREATOR_LICENSE_PATH;
}

export function redirectToCreatorLicense(nextPath = "/me/creator") {
  window.location.href = creatorLicensePath(nextPath);
}

/**
 * Handle API gate errors for profile + license.
 * Returns true if navigation was triggered.
 */
export function handleCreatorGateError(error, fallbackNext = "/me/creator") {
  if (error?.code === "profile_incomplete") {
    window.location.href =
      error.profile_path ||
      `/me/profile?next=${encodeURIComponent(fallbackNext)}`;
    return true;
  }
  if (error?.code === "license_required") {
    redirectToCreatorLicense(fallbackNext);
    return true;
  }
  if (error?.code === "intro_required") {
    window.location.href = error.intro_path || "/me/creator/intro";
    return true;
  }
  return false;
}

/** @deprecated use handleCreatorGateError */
export function handleCreatorProfileError(error, fallbackNext = "/me/creator") {
  return handleCreatorGateError(error, fallbackNext);
}

export function shouldPromptCreatorLicense(status) {
  if (!isCandidateLoggedIn()) return false;
  return Boolean(status?.mustAccept);
}
